import React from 'react'
import RowHome from './RowHome';
import { Table, Card, Text } from '@mantine/core'

const RenovationTable = ({ items, today, tenDays, openModal }) =>
{
  return (
    <Card shadow="md" p={0} radius="lg" withBorder mx="md" className='w-full overflow-hidden'>
      <Table.ScrollContainer minWidth={ 600 }>
        <Table verticalSpacing="sm" highlightOnHover>
          <Table.Thead bg="gray.0">
            <Table.Tr>
              <Table.Th px="md" py="md"><Text size="xs" fw={800} c="dimmed" className="tracking-widest uppercase">Estado</Text></Table.Th>
              <Table.Th><Text size="xs" fw={800} c="dimmed" className="tracking-widest uppercase">Facturación</Text></Table.Th>
              <Table.Th><Text size="xs" fw={800} c="dimmed" className="tracking-widest uppercase">Fecha Límite</Text></Table.Th>
              <Table.Th><Text size="xs" fw={800} c="dimmed" className="tracking-widest uppercase">Cuenta / Cliente</Text></Table.Th>
              <Table.Th></Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody >
            { items && items.length > 0 ? (
              items.map((item) => (
                <RowHome 
                  key={ item._id } 
                  openModal={ openModal } 
                  item={ item } 
                  today={ today } 
                  tenDays={ tenDays } 
                />
              ))
            ) : (
              <Table.Tr>
                <Table.Td colSpan={5} align="center" py="xl">
                  <Text c="dimmed" size="sm">No hay renovaciones pendientes para este criterio.</Text>
                </Table.Td>
              </Table.Tr>
            )}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
    </Card>
  )
}

export default RenovationTable
